import React from 'react';

const TarifarioAereoContext = React.createContext();

export default TarifarioAereoContext;